/**
 * HomeSpace Icon — "Zuhause" Life Space
 *
 * House with heart icon from Figma design.
 * Compatible with Lucide icon API (size + color props).
 *
 * Two states: monochrome (default) and the fixed full-color Figma variant via
 * `colored` (e.g. the list-mode project switcher).
 *
 * @example
 * <HomeSpaceIcon size={16} />
 * <HomeSpaceIcon size={16} colored />
 */
export const HomeSpaceIcon = ({ size = 16, color, colored = false }: { size?: number; color?: string; colored?: boolean }) => {
  if (colored) {
    return (
      <svg width={size} height={size} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.665 7.66406L8.16504 0.664062L0.665039 7.66406" fill="#C1EBE3" fillOpacity="0.5" />
        <path d="M15.665 7.66406L8.16504 0.664062L0.665039 7.66406" stroke="#0F766E" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.66504 8.66406V15.6641H13.665V8.66406" fill="#C1EBE3" />
        <path d="M2.66504 8.66406V15.6641H13.665V8.66406" stroke="#0F766E" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M11.1057 7.6944C10.9009 7.50214 10.657 7.35639 10.3907 7.26712C10.1243 7.17785 9.84188 7.14717 9.5626 7.17718C9.28332 7.20718 9.01383 7.29717 8.77255 7.44098C8.53127 7.58479 8.32391 7.77902 8.16465 8.0104C8.00539 7.77902 7.79803 7.58479 7.55675 7.44098C7.31548 7.29717 7.04598 7.20718 6.7667 7.17718C6.48742 7.14717 6.20496 7.17785 5.93864 7.26712C5.67232 7.35639 5.42843 7.50214 5.22365 7.6944C5.04706 7.86362 4.90653 8.06683 4.81053 8.29179C4.71453 8.51675 4.66504 8.75881 4.66504 9.0034C4.66504 9.24798 4.71453 9.49004 4.81053 9.715C4.90653 9.93996 5.04706 10.1432 5.22365 10.3124L8.16465 13.1644L11.1057 10.3124C11.2822 10.1432 11.4228 9.93996 11.5188 9.715C11.6148 9.49004 11.6643 9.24798 11.6643 9.0034C11.6643 8.75881 11.6148 8.51675 11.5188 8.29179C11.4228 8.06683 11.2822 7.86362 11.1057 7.6944Z"
          fill="#F0FDFA" stroke="#0F766E" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    )
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.66 7.67L8.17 0.67L0.67 7.67"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.67 8.67V15.66H13.66V8.67"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.11 7.7C10.9 7.5 10.66 7.36 10.39 7.27C10.12 7.18 9.84 7.15 9.56 7.18C9.28 7.21 9.01 7.3 8.77 7.44C8.53 7.59 8.32 7.78 8.16 8.01C8.01 7.78 7.8 7.59 7.56 7.44C7.32 7.3 7.05 7.21 6.77 7.18C6.49 7.15 6.2 7.18 5.94 7.27C5.67 7.36 5.43 7.5 5.22 7.7C5.05 7.86 4.91 8.07 4.81 8.29C4.71 8.52 4.67 8.76 4.67 9C4.67 9.25 4.71 9.49 4.81 9.72C4.91 9.94 5.05 10.14 5.22 10.31L8.16 13.17L11.11 10.31C11.28 10.14 11.42 9.94 11.52 9.72C11.61 9.49 11.66 9.25 11.66 9C11.66 8.76 11.61 8.52 11.52 8.29C11.42 8.07 11.28 7.86 11.11 7.7Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
